import {useSortable} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";
import styled from "@emotion/styled";
import * as React from "react";

import {IListEditorItem, IListEditorItemProps} from "./list-editor";
import {IListEditorItemElementProps, ListEditorItemElement} from "./list-editor-item-element";

const ListEditorUl = styled.ul`
    margin-top: 0;
    padding-left: 0;
`;

export interface IListEditorContainerProps<T> {
    items: Array<IListEditorItem<T>>;
    itemComponentFactory: (item: IListEditorItemProps<T>) => JSX.Element;
    onChangeItem: (item: IListEditorItem<T>, index: number) => void;
    onRemoveItem: (index: number) => void;
    className?: string;
}

interface ISortableListEditorItemProps<T> extends IListEditorItemElementProps<T> {
    id: string;
    disabled: boolean;
}

function SortableListEditorItem<T>({id, disabled, ...rest}: ISortableListEditorItemProps<T>) {
    const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({
        id,
        disabled,
    });

    const style: React.CSSProperties = {
        transform: CSS.Transform.toString(transform),
        transition,
        zIndex: isDragging ? 1 : undefined,
    };

    return (
        <ListEditorItemElement
            {...rest}
            dragRef={setNodeRef}
            dragAttributes={disabled ? undefined : attributes}
            dragListeners={disabled ? undefined : listeners}
            dragStyle={style}
            isDragging={isDragging}
        />
    );
}

export function ListEditorContainer<T>(props: IListEditorContainerProps<T>) {
    return (
        <ListEditorUl className={props.className}>
            {props.items.map((item, index) => {
                const itemProps: IListEditorItemProps<T> = {
                    item,
                    order: index,
                    onChange: (x) => props.onChangeItem(x, index),
                    onRemove: () => props.onRemoveItem(index),
                };

                return (
                    <SortableListEditorItem
                        key={item.key}
                        id={item.key}
                        disabled={item.data === null}
                        itemProps={itemProps}
                        itemComponentFactory={props.itemComponentFactory}
                    />
                );
            })}
        </ListEditorUl>
    );
}
